// Modo del lote (v3 lo emite en minúsculas). `generate` es el flujo histórico del wizard;
// `convert` digitaliza ejercicios ya presentes en un PDF (TAN-10240).
export const BATCH_MODE = {
  GENERATE: 'generate',
  CONVERT: 'convert',
};

// Fases del progreso de un lote `convert` mientras está `running` (v3 las emite en minúsculas).
// `extracting` no tiene total ni porcentaje fiables; `converting` ya trae el inventario.
export const BATCH_PHASE = {
  EXTRACTING: 'extracting',
  CONVERTING: 'converting',
};

// Procedencia de la respuesta de una actividad convertida: leída del PDF o deducida por el modelo.
export const ANSWER_ORIGIN = {
  TRANSCRIBED: 'TRANSCRIBED',
  INFERRED: 'INFERRED',
};

// Contrato `source-excerpt/v1`: bbox normalizado en [0,1] con origen arriba a la izquierda,
// páginas en base 1. Cualquier otra versión/espacio se considera no soportado por el renderer.
export const SOURCE_EXCERPT_CONTRACT_VERSION = 'source-excerpt/v1';
export const SOURCE_EXCERPT_COORDINATE_SPACE = 'crop-box-normalized-upright';
export const SOURCE_EXCERPT_PAGE_NUMBER_BASE = 1;

// Motivos por los que un ejercicio detectado no se pudo convertir (contrato de Activity Generator).
export const UNCONVERTIBLE_REASONS = [
  'NO_TEMPLATE',
  'NO_DETERMINABLE_ANSWER',
  'UNREADABLE',
  'PARTIALLY_READABLE',
  'AMBIGUOUS_SEGMENTATION',
  'COMPOUND_EXERCISE',
  'UNSUPPORTED_MEDIA',
  'DUPLICATE',
  'INVALID_STRUCTURE',
  'INVALID_SEMANTICS',
];

// Mismo techo que aplica v3 (CONVERSION_BATCH_ABSOLUTE_PAGE_CEILING).
export const CONVERSION_MAX_PAGES = 20;
export const CONVERSION_SOURCE_TYPE = 'pdf';
export const CONVERSION_QUANTITY_MODE = 'custom';

// Tamaño de página por defecto al paginar no convertibles (GET :id/unconvertible?limit&offset).
export const UNCONVERTIBLE_PAGE_SIZE = 10;

// Techo que acepta v3: un limit mayor se rechaza con 422.
export const UNCONVERTIBLE_MAX_PAGE_SIZE = 100;
